var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('transition',{attrs:{"name":"fade-page","mode":"out-in"}},[(_vm.$route.meta.noCache)?_c('keep-alive',[_c('router-view')],1):_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }